module.exports = __webpack_public_path__ + "img/band-2.9ac04e2a.png";